import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../../i18n/useT';
import FAQAccordion, { ALL_FAQS } from '../faq/FAQAccordion';
import './FAQPreview.css';

export default function FAQPreview() {
  const t = useT();
  const fq = t.faqPreview;

  return (
    <section className="faq-preview section" aria-labelledby="faq-preview-heading">
      <div className="container-narrow">
        <div className="section-header">
          <div className="badge badge-gray">{fq.badge}</div>
          <h2 id="faq-preview-heading" style={{ marginTop: 'var(--space-4)' }}>
            {fq.headline}
          </h2>
          <p>{fq.sub}</p>
        </div>

        <FAQAccordion items={ALL_FAQS} limit={6} />

        <div className="faq-preview__more">
          <p>{fq.sub}</p>
          <div>
            <Link to="/faq" className="btn btn-secondary btn-sm">{fq.viewAll}</Link>
            <Link to="/contact" className="btn btn-ghost btn-sm">{fq.contact}</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
